document.addEventListener('DOMContentLoaded', () => {
  const paymentBlock = document.querySelector('.woocommerce-order-pay .woocommerce-checkout-payment');

  if (!paymentBlock) {
    return;
  }

  let hasReloaded = false;
  let reloadInProgress = false;
  let pendingForcedReload = false;
  let historyRestoreDetected = false;
  let reloadVersion = 0;
  const { jQuery } = window;
  const canObserveJQueryAjax = typeof jQuery === 'function' && jQuery.fn;
  const $doc = canObserveJQueryAjax ? jQuery(document) : null;
  let ajaxObservationActive = false;
  let ajaxFallbackTimeout;

  const reloadPaymentBlock = ({ force = false } = {}) => {
    if (reloadInProgress) {
      if (force) {
        pendingForcedReload = true;
        reloadVersion += 1;
      }

      return;
    }

    if (hasReloaded && !force) {
      return;
    }

    reloadInProgress = true;
    hasReloaded = true;
    pendingForcedReload = false;
    const currentReloadVersion = reloadVersion + 1;
    reloadVersion = currentReloadVersion;

    const url = new URL(window.location.href);
    url.searchParams.set('payment_reload', Date.now().toString());

    fetch(url.toString(), {
      cache: 'no-store',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newPaymentBlock = doc.querySelector('.woocommerce-checkout-payment');

        if (newPaymentBlock && currentReloadVersion === reloadVersion) {
          paymentBlock.innerHTML = newPaymentBlock.innerHTML;
          // Reapply wallet availability checks to the freshly inserted payment methods.
          if (typeof jQuery === 'function' && jQuery.fn) {
            jQuery(document.body).trigger('updated_checkout');
          }
          console.debug('Payment methods reloaded.');
        }
      })
      .then(() => {
        reloadInProgress = false;
        if (pendingForcedReload) {
          reloadPaymentBlock({ force: true });
        }
      }, () => {
        reloadInProgress = false;
        if (pendingForcedReload) {
          reloadPaymentBlock({ force: true });
        }
      });
  };

  function cleanupAjaxObservation() {
    if (!$doc) {
      return;
    }

    $doc.off('ajaxStart.forceReloadPayment');
    $doc.off('ajaxStop.forceReloadPayment');
    ajaxObservationActive = false;

    if (ajaxFallbackTimeout) {
      window.clearTimeout(ajaxFallbackTimeout);
      ajaxFallbackTimeout = null;
    }
  }

  function observeNextAjaxCycle({ forceReloadOnStop = false, fallbackReloadOnNoAjax = false } = {}) {
    if (!$doc) {
      return;
    }

    cleanupAjaxObservation();

    // If a WooCommerce request is already active when BFCache restores the page,
    // treat it as observed so ajaxStop can schedule the final forced reload.
    let sawAjaxActivity = jQuery.active > 0;
    ajaxObservationActive = true;

    function handleAjaxStart() {
      sawAjaxActivity = true;
    }

    function handleAjaxStop() {
      if (!sawAjaxActivity || jQuery.active > 0) {
        return;
      }

      cleanupAjaxObservation();
      reloadPaymentBlock({ force: forceReloadOnStop || historyRestoreDetected });
      historyRestoreDetected = false;
    }

    $doc.on('ajaxStart.forceReloadPayment', handleAjaxStart);
    $doc.on('ajaxStop.forceReloadPayment', handleAjaxStop);

    ajaxFallbackTimeout = window.setTimeout(() => {
      if (!ajaxObservationActive || sawAjaxActivity) {
        return;
      }

      cleanupAjaxObservation();
      if (forceReloadOnStop) {
        historyRestoreDetected = false;
      }
      if (fallbackReloadOnNoAjax && !hasReloaded) {
        reloadPaymentBlock();
      }
    }, 1500);
  }

  window.addEventListener('pageshow', event => {
    const navigation = typeof performance !== 'undefined'
      && typeof performance.getEntriesByType === 'function'
      ? performance.getEntriesByType('navigation')[0]
      : null;
    const isHistoryRestore = event.persisted || (navigation && navigation.type === 'back_forward');

    if (isHistoryRestore) {
      historyRestoreDetected = true;
      observeNextAjaxCycle({ forceReloadOnStop: true });
      reloadPaymentBlock({ force: true });
    }
  });

  if (canObserveJQueryAjax) {
    // Wait for the jQuery AJAX lifecycle to finish before refreshing the payment block.
    observeNextAjaxCycle({ fallbackReloadOnNoAjax: true });
  } else if (document.readyState === 'complete') {
    reloadPaymentBlock();
  } else {
    window.addEventListener('load', reloadPaymentBlock, { once: true });
  }
});
